<template>
	<div></div>
</template>

<script>
import pageMixin from '@/mixins/page-mixin';

export default {
	name: 'DashboardPage',
	mixins: [pageMixin],
	created() {
		this.hidePageLoader();
	},
	metaInfo: {
		title: 'My Dashboard'
	}
};
</script>

<style lang="scss" scoped></style>
